import { IRRELEVANT_DETAILS } from './MerchandisePackDetail.constants';

export default function isDetailRelevant(detail: string) {
  const element = IRRELEVANT_DETAILS.find((irrelevantDetail) =>
    detail.startsWith(irrelevantDetail)
  );

  return element === undefined;
}
